module.exports = __webpack_public_path__ + "img/logo-icon-white.35574a3c.png";